import { render } from "./FormAuth.vue?vue&type=template&id=c04e06d0"
import script from "./FormAuth.vue?vue&type=script&lang=js"
export * from "./FormAuth.vue?vue&type=script&lang=js"

import "./FormAuth.vue?vue&type=style&index=0&id=c04e06d0&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__